module.exports = __webpack_public_path__ + "img/mini-top-banner@2x.bbad0707.png";